// extracted by mini-css-extract-plugin
export default {"noTasksPlaceholder":"NoTasksPlaceholder_noTasksPlaceholder__l3r1M","noTasksWarningTooltip":"NoTasksPlaceholder_noTasksWarningTooltip__8V0U0"};